import {AfterContentInit, Component, Injector, Input} from "@angular/core";
import {provideSearchModel} from "@fedeltapointofsale/data-client";
import {
    registerSelectEditControl
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-select-edit-control.component";
import {MixAndMatchInclusionSearchModel} from "../mix-and-match-inclusion-search-model.service";
import {
    AbstractSingleSelectEditControlComponent
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-single-select-edit-control.component";
import {MixAndMatchInclusionData} from "../mix-and-match.data";
import {MixAndMatchInclusionSearchData} from "../mix-and-match-inclusion-search.data";

@Component({
    selector: "wbo-mix-and-match-inclusion-single-select-edit-control",
    templateUrl: "../../../framework/entity/edit/edit-controls/select-edit-controls/single-select-edit-control.component.html",
    providers: [
        registerSelectEditControl(MixAndMatchInclusionSingleSelectEditControlComponent),
        provideSearchModel(MixAndMatchInclusionSearchModel)
    ]
})
/**
 * This edit control allows selection of either a sellable or a custom product group.
 * For use as a normal input field, it takes a MixAndMatchInclusionData as an input, and internally binds to either its sellable or customObject component.
 * For use as a quick add, the MixAndMatchInclusionData input is not used, as the selected value is never displayed by the control.
 * Do not use this component with a formControlName.
 */
export class MixAndMatchInclusionSingleSelectEditControlComponent extends AbstractSingleSelectEditControlComponent<MixAndMatchInclusionSearchModel> implements AfterContentInit {
    private _inclusion: MixAndMatchInclusionData;

    constructor(model: MixAndMatchInclusionSearchModel, injector: Injector) {
        super(model, injector, "id", "descriptor");
        this.labelSearchField = "name";
    }

    override ngAfterContentInit(): void {
        super.ngAfterContentInit();
        this.subscriptions.add(this.onSelect.subscribe((searchData: MixAndMatchInclusionSearchData) => {
            if (this._inclusion) {
                this._inclusion.sellable.sellableId = null;
                this._inclusion.customObject.customObjectId = null;
                if (searchData.sellable.sellableId) {
                    this._inclusion.sellable = searchData.sellable;
                } else if (searchData.customObject.customObjectId) {
                    this._inclusion.customObject = searchData.customObject;
                }
                this.setValues();
            }
        }));
    }

    @Input()
    get inclusion(): MixAndMatchInclusionData {
        return this._inclusion;
    }

    set inclusion(inclusion: MixAndMatchInclusionData) {
        this._inclusion = inclusion;
        this.setValues();
    }

    private setValues(): void {
        if (this._inclusion) {
            if (this._inclusion.sellable.sellableId) {
                this.objectValue = this._inclusion.sellable;
                this.valueField = "sellableId";
                this.labelField = "name";
                this.value = this._inclusion.sellable.sellableId;
            } else if (this._inclusion.customObject.customObjectId){
                this.objectValue = this._inclusion.customObject;
                this.valueField = "customObjectId";
                this.labelField = "name";
                this.value = this._inclusion.customObject.customObjectId;
            } else {
                this.value = null;
            }
        } else {
            this.value = null;
        }
    }
}
